import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FlightCrewSummaryResponse } from '../models/FlightCrewItem';

@Component({
  selector: 'app-standby-detail',
  templateUrl: './standby-detail.component.html',
  styleUrls: ['./standby-detail.component.scss'],
  standalone: false
})
export class StandbyDetailComponent {
  constructor(
    public dialogRef: MatDialogRef<StandbyDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FlightCrewSummaryResponse
  ) {}

  get totalLatam(): number {
    return this.data?.totalLatam ?? 0;
  }

  get totalExternal(): number {
    return this.data?.totalExternal ?? 0;
  }

  close(): void {
    this.dialogRef.close();
  }
}
